import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {Giustificativi} from "@commons/mapping/Giustificativi";
import {UserTrace} from "@commons/types";
import {FasciaOrariaGG} from "@commons/mapping/FasciaOrariaGG";

export type TipoTabellaANA = "NESSUN_CONTROLLO" | "AMMESSO" | "NON_AMMESSO" | "QUALIFICA_NON_COMPUTABILE";

export interface QualificaEccRecord extends URIAndTrace {
    idAziendaTabelle: number,
    idTabella: number,
    descrizione: string,
    massimaleFT: number,
    idTabellaResidualeFT: number,
    massimalePT: number,
    idTabellaResidualePT: number,
    generaWseA_FT: boolean,
    generaWseNA_FT: boolean,
    generaWseA_PT: boolean,
    generaWseNA_PT: boolean,
    grFTgiornoA: Giustificativi,
    grFTnotteA: Giustificativi,
    grFTgiornoNA: Giustificativi,
    grFTnotteNA: Giustificativi,
    grPTgiornoA: Giustificativi,
    grPTnotteA: Giustificativi,
    grPTgiornoNA: Giustificativi,
    grPTnotteNA: Giustificativi,
    tipoTabellaANA: TipoTabellaANA,
    fasce: FasciaOrariaGG[],
    compensaManualeScarti: boolean,
    compensaManualeA: boolean,
    compensaManualeNA: boolean,
    compensaScarti: boolean,
    compensaA: boolean,
    compensaNA: boolean,
    generaWCompensaScarti: boolean,
    generaWCompensaA: boolean,
    generaWCompensaNA: boolean,
    grCompensaGiornoNC: Giustificativi,
    grCompensaNotteNC: Giustificativi,
    grCompensaGiornoA: Giustificativi,
    grCompensaNotteA: Giustificativi,
    grCompensaGiornoNA: Giustificativi,
    grCompensaNotteNA: Giustificativi,
    insertTrace: UserTrace,
}

export class QualificaEccRecord {
    static usaGiu = (that: QualificaEccRecord, codGiu: string) => {
        const giustificativiUtilizzati: Giustificativi[] = [];
        if (that.grFTgiornoA) {
            giustificativiUtilizzati.push(that.grFTgiornoA);
        }
        if (that.grFTnotteA) {
            giustificativiUtilizzati.push(that.grFTnotteA);
        }
        if (that.grFTgiornoNA) {
            giustificativiUtilizzati.push(that.grFTgiornoNA);
        }
        if (that.grFTnotteNA) {
            giustificativiUtilizzati.push(that.grFTnotteNA);
        }
        if (that.grPTgiornoA) {
            giustificativiUtilizzati.push(that.grPTgiornoA);
        }
        if (that.grPTnotteA) {
            giustificativiUtilizzati.push(that.grPTnotteA);
        }
        if (that.grPTgiornoNA) {
            giustificativiUtilizzati.push(that.grPTgiornoNA);
        }
        if (that.grPTnotteNA) {
            giustificativiUtilizzati.push(that.grPTnotteNA);
        }

        if (that.grCompensaGiornoA) {
            giustificativiUtilizzati.push(that.grCompensaGiornoA);
        }
        if (that.grCompensaNotteA) {
            giustificativiUtilizzati.push(that.grCompensaNotteA);
        }
        if (that.grCompensaGiornoNA) {
            giustificativiUtilizzati.push(that.grCompensaGiornoNA);
        }
        if (that.grCompensaNotteNA) {
            giustificativiUtilizzati.push(that.grCompensaNotteNA);
        }
        if (that.grCompensaGiornoNC) {
            giustificativiUtilizzati.push(that.grCompensaGiornoNC);
        }
        if (that.grCompensaNotteNC) {
            giustificativiUtilizzati.push(that.grCompensaNotteNC);
        }

        for (let indGiu = 0; indGiu < giustificativiUtilizzati.length; ++indGiu) {
            if (codGiu === giustificativiUtilizzati[indGiu].codGiu) {
                return true;
            }
        }

        return false;
    }
}